import { render, staticRenderFns } from "./CodeartPage.vue?vue&type=template&id=5a3ae50c&scoped=true&"
import script from "./CodeartPage.vue?vue&type=script&lang=js&"
export * from "./CodeartPage.vue?vue&type=script&lang=js&"
import style0 from "./CodeartPage.vue?vue&type=style&index=0&id=5a3ae50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ae50c",
  null
  
)

export default component.exports